import translate, { IntlMessageKeys } from '../../i18n'
import {
  CreditBatchReferenceType,
  CreditBatchSourceType,
  CreditBatchStatus,
  CreditBatchTransactionType,
} from './share-type'

export const creditBatchSourceTypeOptions = Object.values(CreditBatchSourceType).map(value => ({
  value,
  label: translate(`creditBatches.sourceType.${value}` as IntlMessageKeys),
}))

export const creditBatchStatusOptions = Object.values(CreditBatchStatus).map(value => ({
  value,
  label: translate(`creditBatches.status.${value}` as IntlMessageKeys),
}))

export const getCreditBatchSourceTypeLabel = (sourceType: CreditBatchSourceType) =>
  translate(`creditBatches.sourceType.${sourceType}` as IntlMessageKeys)

export const getCreditBatchStatusLabel = (status: CreditBatchStatus) =>
  translate(`creditBatches.status.${status}` as IntlMessageKeys)

export const getCreditBatchTransactionTypeLabel = (type: CreditBatchTransactionType) =>
  translate(`creditBatches.transactionType.${type}` as IntlMessageKeys)

export const getCreditBatchReferenceTypeLabel = (referenceType: CreditBatchReferenceType) =>
  translate(`creditBatches.referenceType.${referenceType}` as IntlMessageKeys)
